import {request} from './HttpClient';

export default class Info {
	constructor(app) {
		this.app = app;

		const html = document.documentElement;
		html.classList.replace('no-js', 'js');

		// defaults
		this.lang = html.lang;
		this.country = html.dataset.country;
		this.isDebug = html.classList.contains('debug');
		this.isAdmin = html.classList.contains('admin');

		let skelDataNode = document.getElementById('js-skel-data');
		if (skelDataNode !== null) {
			this.skelData = skelDataNode.dataset;
		}else {
			this.skelData = null;
		}

		request('/getCurrentTranslations?v=20230412') //TODO: Use deployts
			.then(req => req.json())
			.then(data => {
				this.translations = data;
			})
			.catch(error => {
				console.error(error);
				this.translations = false;
			});

		if (!this.isDebug) {
			console.log('%c%s', 'color: red; background: yellow; font-size: 24px;', 'ACHTUNG!');
			console.log(
				'%c%s', 'color: black; font-size: 18px;',
				'Wenn du diese Konsole verwendest, können Angreifer' +
				' möglicherweise mithilfe einer sogenannten Self-XSS-Attacke' +
				' deine Identität stehlen und deine Daten ausspionieren.\n' +
				'Du solltest keinen Code eingeben oder einfügen,' +
				' dessen Auswirkungen du nicht einschätzen kannst.'
			);
		}
	}

	/**
	 * @deprecated
	 */
	set(name, value) {
		this[name] = value;
	}

	/**
	 * @deprecated
	 */
	get(name) {
		return this[name];
	}
}
